import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'user-round-group',
  size: 24,
  node: [
    ['path', { d: 'M17 21a5 5 0 00-10 0', key: '35qx9b' }],
    ['path', { d: 'M22 10.5a3.5 3.5 0 00-5.507-2.868', key: '1nguyj' }],
    ['path', { d: 'M7.507 7.632A3.5 3.5 0 002 10.5', key: '19g32s' }],
    ['circle', { cx: '12', cy: '13', r: '3', key: '1vg3eu' }],
    ['circle', { cx: '18.5', cy: '4.5', r: '2.5', key: '1ona2d' }],
    ['circle', { cx: '5.5', cy: '4.5', r: '2.5', key: '1sh5th' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name UserRoundGroup
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcgMjFhNSA1IDAgMDAtMTAgMCIgLz4KICA8cGF0aCBkPSJNMjIgMTAuNWEzLjUgMy41IDAgMDAtNS41MDctMi44NjgiIC8+CiAgPHBhdGggZD0iTTcuNTA3IDcuNjMyQTMuNSAzLjUgMCAwMDIgMTAuNSIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEzIiByPSIzIiAvPgogIDxjaXJjbGUgY3g9IjE4LjUiIGN5PSI0LjUiIHI9IjIuNSIgLz4KICA8Y2lyY2xlIGN4PSI1LjUiIGN5PSI0LjUiIHI9IjIuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-round-group
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UserRoundGroup = createLucideIcon(__iconData);

export default UserRoundGroup;
